module.exports = __webpack_public_path__ + "static/media/lips.f2d710f6.png";